import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { EggSaleRecord, IsoDate, NumericString } from '@henlytics/types'
import { api } from '../lib/api-client'
import { queryKeys } from '../lib/query-keys'
import { clientUuid } from '../lib/uuid'

export function useSales(batchId?: string) {
  return useQuery({
    queryKey: queryKeys.sales(batchId),
    queryFn: ({ signal }) =>
      api.get<EggSaleRecord[]>(batchId ? `/sales?batchId=${batchId}` : '/sales', signal),
  })
}

export interface NewSale {
  batchId?: string | null
  saleDate: IsoDate
  grade?: string | null
  qtyEggs: number
  unitPrice: NumericString
  totalAmount: NumericString
  customer?: string | null
  clientUuid?: string
}

export function useCreateSale(batchId?: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: NewSale) =>
      api.post<EggSaleRecord>('/sales', { ...input, clientUuid: input.clientUuid ?? clientUuid() }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.sales(batchId) })
      void queryClient.invalidateQueries({ queryKey: queryKeys.sales() })
      void queryClient.invalidateQueries({ queryKey: queryKeys.reports })
    },
  })
}

export function useVoidSale(batchId?: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (saleId: string) => api.post<EggSaleRecord>(`/sales/${saleId}/void`, {}),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.sales(batchId) })
      void queryClient.invalidateQueries({ queryKey: queryKeys.sales() })
      void queryClient.invalidateQueries({ queryKey: queryKeys.reports })
    },
  })
}
